import React from "react";

import "./matchInfo.css";

// import ProgressBar from "@ramonak/react-progress-bar";
import ProgressBar from "react-bootstrap/ProgressBar";

const MatchInfo = (prop) => {
  return (
    <div className="matchInfo">
      <div className="matchInfo-wrapper">
        <div className="matchInfo-part1">
          <div className="matchInfo-part1-top">
            <div className="matchInfo-part1-top-left">
              <h6 className="match">
                {prop.matchProfile ? prop.matchProfile.days_played : 0}/104
              </h6>
              <h6 className="match-text"> Matches Predicted</h6>
            </div>
            <div className="matchInfo-rank-wrapper">
              <p className="rank-text">Your Rank{" "}</p>
              <p className="rank-count">
                {prop.matchProfile ? prop.matchProfile.user_position : 0}
              </p>
            </div>
          </div>
          <div className="matchInfo-part1-middle">
            <div className="matchInfo-progressbar-wrapper">
              <ProgressBar
              max={104}
                now={prop.matchProfile ? prop.matchProfile.days_played : 0}
              />
              {/* <ProgressBar
                completed={
                  prop.matchProfile ? prop.matchProfile.days_played : 0
                }
                maxCompleted={23}
                className="wrapper"
                barContainerClassName="container"
                completedClassName="barCompleted"
                labelClassName="label"
              /> */}
            </div>
          </div>
        </div>
        <div className="matchInfo-part2">
          <div className="matchInfo-part2-wrapper">
            <div className="matchInfo-right-prediction">
              <h4>{prop.scoreProfile ? prop.scoreProfile.total_win : 0}</h4>
              <div className="text">
                <p>Right</p>
                <p>Predictions</p>
              </div>
            </div>
            <div className="matchInfo-wrong-prediction">
              <h4>{prop.scoreProfile ? prop.scoreProfile.total_lose : 0}</h4>
              <div className="text">
                <p>Wrong</p>
                <p>Predictions</p>
              </div>
            </div>
            <div className="matchInfo-missed-prediction">
              <h4>
                {prop.scoreProfile
                  ? parseInt(prop.matchProfile.total_questions) -
                    (parseInt(prop.scoreProfile.total_lose) +
                      parseInt(prop.scoreProfile.total_win))
                  : 0}
              </h4>
              <div className="text">
                <p>Missed</p>
                <p>Predictions</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatchInfo;
